// extracted by mini-css-extract-plugin
export var backgroundCover = "two-col-image-promo-module--backgroundCover--SGQqD";
export var backgroundImage = "two-col-image-promo-module--backgroundImage--eiSKq";
export var darkFont = "two-col-image-promo-module--darkFont--C1QHJ";
export var lightFont = "two-col-image-promo-module--lightFont--Q49ac";
export var smallTitle = "two-col-image-promo-module--smallTitle--ixxdg";
export var staggeredColumnHeight = "two-col-image-promo-module--staggeredColumnHeight--vFNcb";
export var text = "two-col-image-promo-module--text--cSkZS";
export var twoColImagePromo = "two-col-image-promo-module--twoColImagePromo--UkO8i";